(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-service.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-service.js');
"use strict";


const logger = svs.spelpaus.logger;
const jupiter = svs.core.jupiter;
const CALL_STATUS = svs.spelpaus.constants.CALL_STATUS;
const getActiveSuspensionsAsync = async () => {
  try {
    logger.debug('Call to getActiveSuspensionsAsync');
    const options = {
      method: 'GET',
      path: '/player/1/suspensions'
    };
    const _await$jupiter$callAs = await jupiter.callAsync(options),
      response = _await$jupiter$callAs.response,
      status = _await$jupiter$callAs.status;
    logger.debug('Call to getActiveSuspensionsAsync got response');
    if (status && status === CALL_STATUS.SUCCESS) {
      return response.suspensions;
    }
    return [];
  } catch (error) {
    logger.warn('Error getting Active Suspensions Async', error);
    return [];
  }
};
const getHistorySuspensionsAsync = async () => {
  try {
    logger.debug('Call to getHistorySuspensionsAsync');
    const options = {
      method: 'GET',
      path: '/player/1/suspensionhistory'
    };
    const _await$jupiter$callAs2 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs2.response,
      status = _await$jupiter$callAs2.status;
    logger.debug('Call to getHistorySuspensionsAsync got response');
    if (status && status === CALL_STATUS.SUCCESS) {
      return response.suspensions;
    }
    return [];
  } catch (error) {
    logger.warn('Error getting History Suspensions Async', error);
    return [];
  }
};
const postNewSuspensionAsync = async (suspension, postToken) => {
  try {
    logger.debug('postNewSuspensionAsync, suspension:', suspension);
    logger.debug('postNewSuspensionAsync, postToken:', postToken);
    const suspensionModded = suspension;
    const data = {
      suspensions: [suspensionModded]
    };
    if (postToken) {
      logger.debug("adding postToken: ".concat(postToken));
      data.postToken = postToken;
    }
    const options = {
      path: '/player/1/suspensions',
      method: 'POST',
      data
    };
    logger.debug('====== Call to postNewSuspensionAsync with options: ', options);
    const _await$jupiter$callAs3 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs3.response,
      status = _await$jupiter$callAs3.status;
    logger.debug('====== Call to postNewSuspensionAsync got response, status: ', status);
    if (status && status === CALL_STATUS.SUCCESS) {
      let suspensions = [];
      if (response.suspensions) {
        suspensions = response.suspensions;
      }
      return {
        suspensions,
        status
      };
    }
    return {
      status
    };
  } catch (error) {
    logger.warn('Error setting suspensions Async', error);
    return {
      error,
      status: CALL_STATUS.ERROR
    };
  }
};
svs.spelpaus.pages.svsSuspension.SvsSuspensionService = {
  getActiveSuspensionsAsync,
  getHistorySuspensionsAsync,
  postNewSuspensionAsync
};

 })(window);